import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const s = StyleSheet.create({
  page: { padding: 15, paddingBottom: 30, fontFamily: 'Helvetica', fontSize: 8, color: '#000' },
  grid2Col: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 15, alignItems: 'stretch' },
  box: { borderWidth: 1, borderColor: '#000', borderRadius: 4, padding: 8, alignItems: 'center', justifyContent: 'center' },
  textBold: { fontFamily: 'Helvetica-Bold' },

  headerContainer: { flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 2, borderBottomColor: '#000', paddingBottom: 15, marginBottom: 15 },
  logoCol: { width: '25%', alignItems: 'center', justifyContent: 'center' },
  logo: { width: 120, height: 70, objectFit: 'contain' },
  infoCol: { width: '45%', alignItems: 'center', textAlign: 'center', marginTop: '14px' },
  invoiceCol: { width: '28%', justifyContent: 'center' },

  // TRUCO APLICADO: Quitamos el borderWidth general de la tabla
  table: { width: '100%', marginBottom: 20 },
  // Y asignamos los bordes a las filas (Arriba, Izquierda y Abajo)
  tableHeader: { flexDirection: 'row', backgroundColor: '#e0e0e0', borderTopWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1, borderColor: '#000', alignItems: 'center' },
  tableRow: { flexDirection: 'row', borderLeftWidth: 1, borderBottomWidth: 1, borderColor: '#000', alignItems: 'stretch' },

  // A todas las columnas les damos el borde derecho para cerrar la cuadrícula perfecta
  colEnum: { width: '4%', padding: 3, borderRightWidth: 1, borderRightColor: '#000', textAlign: 'center', flexDirection: 'column', justifyContent: 'center' },
  colCode: { width: '12%', padding: 3, borderRightWidth: 1, borderRightColor: '#000', flexDirection: 'column', justifyContent: 'center' },
  colDesc: { width: '40%', padding: 2, borderRightWidth: 1, borderRightColor: '#000' },
  colQty: { width: '8%', padding: 3, borderRightWidth: 1, borderRightColor: '#000', textAlign: 'center', flexDirection: 'column', justifyContent: 'center' },
  colDcto: { width: '8%', padding: 3, borderRightWidth: 1, borderRightColor: '#000', textAlign: 'right', flexDirection: 'column', justifyContent: 'center' },
  colIva: { width: '8%', padding: 3, borderRightWidth: 1, borderRightColor: '#000', textAlign: 'center', flexDirection: 'column', justifyContent: 'center' },
  colNeto: { width: '12%', padding: 3, borderRightWidth: 1, borderRightColor: '#000', textAlign: 'right', flexDirection: 'column', justifyContent: 'center' },
  colTot: { width: '12%', padding: 3, borderRightWidth: 1, borderRightColor: '#000', textAlign: 'right', flexDirection: 'column', justifyContent: 'center' },

  totalsWrapper: { flexDirection: 'row', justifyContent: 'space-between' },
  paymentBox: { width: '56%', padding: 10, borderWidth: 1, borderColor: '#000', borderRadius: 4, backgroundColor: '#f8fafc', fontSize: 8.5 },
  paymentRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4 },
  totalesBox: { width: '40%', borderWidth: 1, borderColor: '#000' },
  totalRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#000' },
  totalLabel: { width: '50%', padding: 6, fontFamily: 'Helvetica-Bold', borderRightWidth: 1, borderRightColor: '#000' },
  totalValue: { width: '50%', padding: 6, textAlign: 'right' },
  granTotalRow: { flexDirection: 'row', backgroundColor: '#e0e0e0' },

  footerInfo: { position: 'absolute', bottom: 20, left: 30, right: 30, textAlign: 'center', fontSize: 8, color: '#555', borderTopWidth: 1, borderTopColor: '#000', paddingTop: 10, fontFamily: 'Helvetica-Bold' },
  pageNumber: { position: 'absolute', bottom: 10, right: 30, fontSize: 8, color: '#777' }
});

export const FacturaFormal = ({
  carrito = [],
  totales = {},
  infoNegocio = {},
  numeroFactura,
  tituloDocumento = "FACTURA DE VENTA",
  ventaId = "000000",
  fechaVenta,
  cajero = "Cajero",
  clienteNombre,
  clienteDocumento,
  clienteTelefono,
  clienteDireccion,
  clienteEmail,
  metodoPago = "EFECTIVO",
  efectivoRecibido = 0,
  montoTransferencia = 0,
  cambioEntregado = 0
}) => {
  const { subtotal = 0, impuestos = 0, total = 0, totalDescuento = 0 } = totales;
  const numeroMostrar = numeroFactura || (ventaId.toString().includes('-') ? ventaId.toString().split('-')[0].toUpperCase() : ventaId);
  const fechaImpresion = fechaVenta ? new Date(fechaVenta) : new Date();

  const logoS3 = infoNegocio.logo_url || infoNegocio.logo;
  const logoConCacheBuster = logoS3 ? `${logoS3}?t=${Date.now()}` : null;

  return (
    <Document>
      <Page size="LETTER" style={s.page}>

        {/* ENCABEZADO */}
        <View style={s.headerContainer}>
          <View style={s.logoCol}>
            {infoNegocio.logo_url ? (
              <Image
                src={logoConCacheBuster}
                style={s.logo}
              />
            ) : (
              <Text style={{ ...s.textBold, fontSize: 18, textAlign: 'center' }}>{infoNegocio.nombre}</Text>
            )}
          </View>
          <View style={s.infoCol}>
            <Text style={{ ...s.textBold, fontSize: 13, textTransform: 'uppercase', marginBottom: 2 }}>{infoNegocio.nombre_legal || infoNegocio.nombre}</Text>
            <Text style={{ fontSize: '10px' }}>NIT: {infoNegocio.nit || '000.000.000-0'}</Text>
            <Text style={{ fontSize: '10px' }}>{infoNegocio.direccion || 'Dirección no registrada'}</Text>
            <Text style={{ fontSize: '10px' }}>Tel: {infoNegocio.telefono || 'Sin teléfono'}</Text>
          </View>
          <View style={s.invoiceCol}>
            <View style={s.box}>
              <Text style={{ ...s.textBold, fontSize: 11, marginBottom: 4 }}>{tituloDocumento}</Text>
              <Text style={{ ...s.textBold, fontSize: 14, color: '#d32f2f' }}>No. {numeroMostrar}</Text>
            </View>
          </View>
        </View>

        {/* CLIENTE Y FECHA */}
        <View style={s.grid2Col}>
          <View style={{ width: '65%', borderWidth: 1, borderColor: '#000' }}>
            <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#000' }}>
              <Text style={{ width: '20%', backgroundColor: '#e0e0e0', padding: 5, ...s.textBold, borderRightWidth: 1, borderRightColor: '#000' }}>Cliente:</Text>
              <Text style={{ width: '80%', padding: 5, textTransform: 'uppercase' }}>{clienteNombre || 'CONSUMIDOR FINAL'}</Text>
            </View>

            <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#000' }}>
              <Text style={{ width: '20%', backgroundColor: '#e0e0e0', padding: 5, ...s.textBold, borderRightWidth: 1, borderRightColor: '#000' }}>NIT/CC:</Text>
              <Text style={{ width: '30%', padding: 5, borderRightWidth: 1, borderRightColor: '#000' }}>{clienteDocumento || '222222222222'}</Text>
              <Text style={{ width: '20%', backgroundColor: '#e0e0e0', padding: 5, ...s.textBold, borderRightWidth: 1, borderRightColor: '#000' }}>Teléfono:</Text>
              <Text style={{ width: '30%', padding: 5 }}>{clienteTelefono || ''}</Text>
            </View>

            <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#000' }}>
              <Text style={{ width: '20%', backgroundColor: '#e0e0e0', padding: 5, ...s.textBold, borderRightWidth: 1, borderRightColor: '#000' }}>Dirección:</Text>
              <Text style={{ width: '80%', padding: 5 }}>{clienteDireccion || ''}</Text>
            </View>

            <View style={{ flexDirection: 'row' }}>
              <Text style={{ width: '20%', backgroundColor: '#e0e0e0', padding: 5, ...s.textBold, borderRightWidth: 1, borderRightColor: '#000' }}>Correo:</Text>
              <Text style={{ width: '80%', padding: 5 }}>{clienteEmail || ''}</Text>
            </View>
          </View>

          <View style={{ width: '32%', borderWidth: 1, borderColor: '#000' }}>
            <Text style={{ backgroundColor: '#e0e0e0', padding: 5, textAlign: 'center', ...s.textBold, borderBottomWidth: 1, borderBottomColor: '#000' }}>Emisión de Factura</Text>
            <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#000' }}>
              <Text style={{ width: '40%', backgroundColor: '#e0e0e0', padding: 5, ...s.textBold, borderRightWidth: 1, borderRightColor: '#000' }}>Fecha</Text>
              <Text style={{ width: '60%', padding: 5, textAlign: 'center' }}>{fechaImpresion.toLocaleDateString()} {fechaImpresion.toLocaleTimeString([])}</Text>
            </View>
            <View style={{ flexDirection: 'row' }}>
              <Text style={{ width: '40%', backgroundColor: '#e0e0e0', padding: 5, ...s.textBold, borderRightWidth: 1, borderRightColor: '#000' }}>Cajero</Text>
              <Text style={{ width: '60%', padding: 5, textAlign: 'center' }}>{cajero}</Text>
            </View>
            <View style={{ flexDirection: 'row' }}>
              <Text style={{ width: '40%', backgroundColor: '#e0e0e0', padding: 5, borderRightWidth: 1, borderRightColor: '#000' }}> </Text>
              <Text style={{ width: '60%', padding: 5 }}> </Text>
            </View>
          </View>
        </View>

        {/* TABLA DE PRODUCTOS */}
        <View style={s.table}>
          <View style={s.tableHeader}>
            <Text style={s.colEnum}>#</Text>
            <Text style={s.colCode}>CÓDIGO</Text>
            <Text style={{ ...s.colDesc, textAlign: 'center' }}>DESCRIPCIÓN</Text>
            <Text style={s.colQty}>CANT</Text>
            <Text style={s.colDcto}>DCTO</Text>
            <Text style={s.colIva}>IVA</Text>
            <Text style={s.colNeto}>V. NETO</Text>
            <Text style={s.colTot}>V. TOTAL</Text>
          </View>

          {carrito.map((item, index) => {
            const cantidad = item.numItems || item.cantidad || 1;
            const precioVenta = Number(item.precioVenta || 0);
            const porcentajeDescuento = Number(item.descuento || 0);
            const porcentajeIva = Number(item.iva || 0);
            ;
            const valorNeto = precioVenta * cantidad;
            const dineroDescontado = valorNeto * (porcentajeDescuento / 100);
            const baseImponible = valorNeto - dineroDescontado;
            const dineroIva = baseImponible * (porcentajeIva / 100);
            const valorTotalFila = baseImponible + dineroIva;

            return (
              <View style={s.tableRow} key={index} wrap={false}>
                <View style={s.colEnum}>
                  <Text>{index + 1}</Text>
                </View>
                <View style={s.colCode}>
                  <Text style={{ fontSize: 8 }}>{item.codigo_barras || item.codigo || 'S/N'}</Text>
                </View>
                <View style={s.colDesc}>
                  <Text style={s.textBold}>{item.nombre}</Text>
                </View>
                <View style={s.colQty}>
                  <Text>{cantidad}</Text>
                </View>
                <View style={s.colDcto}>
                  <Text>${dineroDescontado.toLocaleString('es-CO')}</Text>
                </View>
                <View style={s.colIva}>
                  <Text>{porcentajeIva}%</Text>
                </View>
                <View style={s.colNeto}>
                  <Text>${precioVenta.toLocaleString('es-CO')}</Text>
                </View>
                <View style={s.colTot}>
                  <Text style={s.textBold}>${valorTotalFila.toLocaleString('es-CO')}</Text>
                </View>
              </View>
            );
          })}
        </View>

        <View style={s.totalsWrapper} wrap={false}>

          <View style={s.paymentBox}>
            <Text style={{ ...s.textBold, marginBottom: 6, fontSize: 10, borderBottomWidth: 1, borderBottomColor: '#ccc', paddingBottom: 4 }}>DETALLES DEL PAGO</Text>

            <View style={s.paymentRow}>
              <Text style={s.textBold}>Medio de Pago:</Text>
              <Text style={s.textBold}>{metodoPago?.toUpperCase() || 'EFECTIVO'}</Text>
            </View>

            {metodoPago === 'Efectivo' && (
              <>
                <View style={s.paymentRow}>
                  <Text>Efectivo Recibido:</Text>
                  <Text>${Number(efectivoRecibido || total).toLocaleString('es-CO')}</Text>
                </View>
                <View style={s.paymentRow}>
                  <Text>Cambio Entregado:</Text>
                  <Text>${Number(cambioEntregado || 0).toLocaleString('es-CO')}</Text>
                </View>
              </>
            )}
            {metodoPago === 'Mixto' && (
              <>
                <View style={s.paymentRow}>
                  <Text>Pagado en Efectivo:</Text>
                  <Text>${Number(efectivoRecibido || 0).toLocaleString('es-CO')}</Text>
                </View>
                <View style={s.paymentRow}>
                  <Text>Pagado en Transferencia:</Text>
                  <Text>${Number(montoTransferencia || 0).toLocaleString('es-CO')}</Text>
                </View>
              </>
            )}
            {metodoPago === 'Credito' && (
              <>
                <View style={s.paymentRow}>
                  <Text>Estado de Cuenta:</Text>
                  <Text style={{ color: '#d32f2f' }}>Abonado a Cartera</Text>
                </View>
                {/* Se muestra el abono inicial si el cliente entregó algo de dinero */}
                {Number(efectivoRecibido) > 0 && (
                  <View style={s.paymentRow}>
                    <Text>Abono Inicial (Efectivo):</Text>
                    <Text>${Number(efectivoRecibido).toLocaleString('es-CO')}</Text>
                  </View>
                )}
                {/* Se calcula matemáticamente la deuda restante */}
                <View style={s.paymentRow}>
                  <Text style={{ ...s.textBold }}>Saldo Pendiente:</Text>
                  <Text style={{ ...s.textBold, color: '#d32f2f' }}>
                    ${Number((total || 0) - (efectivoRecibido || 0)).toLocaleString('es-CO')}
                  </Text>
                </View>
              </>
            )}

            <View style={{ marginTop: 8, paddingTop: 6, borderTopWidth: 1, borderTopColor: '#ccc' }}>
              <Text style={{ ...s.textBold, marginBottom: 2 }}>Términos y Observaciones:</Text>
              <Text style={{ color: '#444' }}>Este documento no constituye una factura electrónica de venta.</Text>
              <Text style={{ color: '#444' }}>Estimado cliente, según la ley estatutaria 1581 de 2012 habeas data, que regula los deberes que asisten a los Responsables de tratamiento de datos personales, le informamos que { infoNegocio.nombre_legal } manejará los datos que suministras en nuestras cajas para fines informativos y promocionales de nuestra organización.</Text>
            </View>
          </View>

          <View style={s.totalesBox}>
            <View style={s.totalRow}>
              <Text style={s.totalLabel}>Subtotal Neto</Text>
              <Text style={s.totalValue}>${Number(subtotal || total).toLocaleString('es-CO')}</Text>
            </View>

            {impuestos > 0 && (
              <View style={s.totalRow}>
                <Text style={s.totalLabel}>IVA / Impuestos</Text>
                <Text style={s.totalValue}>${Number(impuestos).toLocaleString('es-CO')}</Text>
              </View>
            )}

            {totalDescuento > 0 && (
              <View style={s.totalRow}>
                <Text style={{ ...s.totalLabel, color: '#d32f2f' }}>Descuentos Totales</Text>
                <Text style={{ ...s.totalValue, color: '#d32f2f' }}>-${Number(totalDescuento).toLocaleString('es-CO')}</Text>
              </View>
            )}

            {/* Mantenemos el cambio de título, pero eliminamos la fila roja extraña debajo */}
            <View style={s.granTotalRow}>
              <Text style={{ ...s.totalLabel, fontSize: 10 }}>
                {metodoPago === 'Credito' ? 'TOTAL FACTURA' : 'TOTAL A PAGAR'}
              </Text>
              <Text style={{ ...s.totalValue, ...s.textBold, fontSize: 12 }}>
                ${Number(total).toLocaleString('es-CO')}
              </Text>
            </View>
          </View>
        </View>

        <Text style={s.footerInfo} fixed>
          SISTEMA POS GENERADO POR YUGONUB S.A.S - WWW.POS.YUGONUB.COM
        </Text>

        <Text style={s.pageNumber} render={({ pageNumber, totalPages }) => (
          `Página ${pageNumber} de ${totalPages}`
        )} fixed />

      </Page>
    </Document>
  );
};